import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";

const Redirector = () => {
  const { userId, isAdmin, viewAsUid, role } = useSelector(
    (state) => state.auth,
  );
  const navigate = useNavigate();
  const location = useLocation();

  // Save current page when navigating
  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/login") {
      localStorage.setItem("lastVisitedPage", location.pathname);
    }
  }, [location]);

  // Get the last visited page from localStorage
  const lastPage = localStorage.getItem("lastVisitedPage");

  if (!userId) return <Navigate to="/login" replace />;

  // Gestock-only users always land on /menu (only Gestock button visible).
  if (role === "gestock" && !viewAsUid) return <Navigate to="/menu" replace />;

  // If admin is viewing as someone (Gestock), stay on dashboard
  if (isAdmin && viewAsUid) {
    return <Navigate to="/dashboard" replace />;
  }

  // If there's a saved page and user is admin, redirect to it
  if (isAdmin && !viewAsUid && lastPage && location.pathname === "/") {
    return <Navigate to={lastPage} replace />;
  }

  if (isAdmin && !viewAsUid) return <Navigate to="/menu" replace />;
  return <Navigate to="/dashboard" replace />;
};

export default Redirector;
